import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=61553c45&lang=less&scoped=true"
import "./Product.vue?vue&type=style&index=1&id=61553c45&lang=less"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61553c45"]])

export default __exports__